'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.DialogAnimations = void 0;
(function(DialogAnimations) {
    DialogAnimations["FadeIn"] = 'fade-in';
    DialogAnimations["FadeInFromBottom"] = 'fade-in-from-bottom';
    DialogAnimations["FadeInFromLeft"] = 'fade-in-from-left';
    DialogAnimations["FadeInFromRight"] = 'fade-in-from-right';
    DialogAnimations["FadeInFromTop"] = 'fade-in-from-top';
})(exports.DialogAnimations || (exports.DialogAnimations = {}));
exports.DialogSizes = void 0;
(function(DialogSizes) {
    DialogSizes["Auto"] = 'auto';
    DialogSizes["Fullscreen"] = 'fullscreen';
    DialogSizes["Large"] = 'large';
    DialogSizes["Medium"] = 'medium';
    DialogSizes["Small"] = 'small';
    DialogSizes["Unlimited"] = 'unlimited';
    DialogSizes["Xlarge"] = 'xlarge';
    DialogSizes["Xsmall"] = 'xsmall';
    DialogSizes["Xxlarge"] = 'xxlarge';
    DialogSizes["Xxsmall"] = 'xxsmall';
})(exports.DialogSizes || (exports.DialogSizes = {}));
exports.DialogTypes = void 0;
(function(DialogTypes) {
    DialogTypes["Drawer"] = 'drawer';
    DialogTypes["Modal"] = 'modal';
})(exports.DialogTypes || (exports.DialogTypes = {}));
exports.DrawerAnimations = void 0;
(function(DrawerAnimations) {
    DrawerAnimations["FadeInFromLeft"] = 'fade-in-from-left';
    DrawerAnimations["FadeInFromRight"] = 'fade-in-from-right';
})(exports.DrawerAnimations || (exports.DrawerAnimations = {}));
//# sourceMappingURL=dialog.js.map
